module.exports = __webpack_public_path__ + "img/verification_code_login_logo.9b63b59f.png";